export enum DataModel {
  PoultryWeights = 1,
  hydroIntel = 6,
  Bees = 8,
  RuminTech = 2,
  Bpac = 12,
  Gas = 7,
  Radar = 9
}
